module.exports = __webpack_public_path__ + "static/media/intro.3c35ba0a.mp3";